import ReactGA from "react-ga4";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import jll_logo from "../images/JLL_logo.png";
import legal_general_logo from "../images/legal_general_logo.png";
import mcgee_logo from "../images/mcgee_logo.png";
import waterman_logo from "../images/waterman_logo.svg";
import mace_logo from "../images/mace_logo.webp";
import london_oriental_logo from "../images/london_oriental_logo.jpg";
import overbury_logo from "../images/overbury_logo.png";
import gs1_logo from "../images/gs_1_logo.png";
import endurance_land_logo from "../images/endurance_land_logo.png";
import tier_global_uk from "../images/tier_global_uk_ltd_logo.jpeg";
import alles_logo from "../images/alliesandmorrison_logo.jpg";
import { useMediaQuery } from "@mui/material";
import laptop_hero from "../images/website.webp";
export const Home = (props) => {
  const hangleClickForGA = (e) => {
    ReactGA.event({
      category: "User",
      action: `Clicked on home - ${e.currentTarget.href || e.target.innerHTML}`,
    });
  };

  const isMobile = useMediaQuery("(max-width:464px)");
  const isTablet = useMediaQuery("(min-width:465px) and (max-width:992px)");
  const deviceType = isMobile ? "mobile" : isTablet ? "tablet" : "desktop";

  const logo_container_style = {
    width: "90px",
    height: "70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1px",
    margin: "0 20px",
  };

  const logo_style = {
    maxWidth: "90%",
    objectFit: "contain",
    margin: "0 auto",
  };

  const logos = [
    { src: jll_logo, height: "38px", url: "https://www.jll.co.uk/" },
    { src: legal_general_logo, height: "60px", url: "https://www.legalandgeneral.com/" },
    { src: mcgee_logo, height: "24px", url: "https://www.mcgee.co.uk/" },
    { src: mace_logo, height: "50px", url: "https://www.macegroup.com/" },
    { src: london_oriental_logo, height: "80px", url: "https://www.lo.london/" },
    { src: waterman_logo, height: "80px", url: "https://www.watermangroup.com/locations/london/" },
    { src: overbury_logo, height: "40px", url: "https://www.overbury.com/" },
    { src: gs1_logo, height: "40px", url: "https://www.gs1uk.org/" },
    { src: endurance_land_logo, height: "60px", url: "https://www.enduranceland.com/" },
    { src: tier_global_uk, height: "40px", url: "https://tier-global.com/" },
    { src: alles_logo, height: "100px", url: "https://www.alliesandmorrison.com/" },
    {
      src: "https://circuland-website-images.s3.eu-west-2.amazonaws.com/gxn_logo.webp",
      height: "20px",
      url: "https://gxn.3xn.com/",
    },
    {
      src: "https://circuland-website-images.s3.eu-west-2.amazonaws.com/naturalBuildingSystems_logo.jpg",
      height: "35px",
      url: "https://naturalbuildingsystems.com/",
    },
    {
      src: "https://circuland-website-images.s3.eu-west-2.amazonaws.com/kingspan_logo.webp",
      height: "34px",
      url: "https://www.kingspan.com/gb/en/",
    },
  ];

  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 1200 }, items: 5, partialVisibilityGutter: 40 },
    desktop: { breakpoint: { max: 1200, min: 992 }, items: 4, partialVisibilityGutter: 25 },
    tablet: { breakpoint: { max: 992, min: 464 }, items: 3, partialVisibilityGutter: 20 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 2, partialVisibilityGutter: 15 },
  };

  return (
    <div id="home" className="section-container">
      <div className="page">
        <div
          id="homeunderlay"
          className="w-[99%] max-w-[1400px] h-full   mt-[120px] lg:mt-[40px] mb-[150px] flex justify-center content-center flex-col"
        >
          <div className="w-[97%] pl-2 flex flex-col justify-center items-center">
            <div className="xl:gap-[70px] pl-2 pt-20 lg:gap-[40px]  flex flex-row max-lg:flex-col justify-center max-lg:items-center">
              <div className="max-sm:w-[95%] max-lg:w-[85%] mb-12   lg:mb-40 pl-2 flex items-start justify-start font-geistNumber font-normal text-[16px] leading-[27px] text-black  flex-col  space-y-12">
                <h3 className="font-geistNumber font-bold text-center pl-2 lg:mt-60 mt-5 lg:text-[37px] xl:text-[49px] lg:leading-[55px] text-[33px] text-[rgb(19,19,22)]">
                  The Data Power Station for Life Cycle Documentation
                </h3>
                <div className="flex justify-center items-center">
                  <span className="xl:text-[16px] lg:text-[17px] text-[15px] text-center" style={{ color: "rgb(94, 95, 110)" }}>
                    Holistic digital records for construction products and buildings through Materials Passports.Track compliance
                    on Carbon, Circularity, H&S and Technical Specs.
                  </span>
                </div>
                <div className="  w-full flex justify-center items-center flex-col pt-4">
                  <a href="#contact" className="page-scroll" onClick={(event) => hangleClickForGA(event)}>
                    <button className="lg:w-[180px] lg:h-[43px] w-[160px] h-[36px] bg-gradient-custom-reverse opacity-90 font-bold lg:text-[18px] text-[14px] rounded-[80px] text-white border-none m-0 hover:bg-[#8e2f94] hover:opacity-100 flex items-center justify-center">
                      Get in touch
                    </button>
                  </a>
                </div>
              </div>
              <div className="flex justify-center items-center  lg:pt-20 pl-12 w-[90%] max-md:w-full max-sm:pb-8 max-sm:pr-16  ">
                <div className="h-auto flex">
                  <img src={laptop_hero} className="max-lg:w-[400px] " alt="Circuland top graphic" />
                </div>
              </div>
            </div>
            <div>
              <div className="flex flex-col ">
                <span className=" text-black opacity-90 lg:text-[16px] text-[12px] pt-4   text-center justify-center items-center">
                  Trusted by Customers & Design Partners
                </span>
                <div className=" pl-16 w-full max-w-[1200px] max-xl:max-w-[1100px] max-lg:max-w-[880px] max-md:max-w-[650px] max-sm:max-w-[370px] py-[10px]">
                  <Carousel
                    ssr
                    partialVisible
                    responsive={responsive}
                    infinite
                    autoPlay
                    autoPlaySpeed={3000}
                    keyBoardControl
                    customTransition="transform 300ms ease-in-out"
                    transitionDuration={300}
                    containerClass="carousel-container"
                    sliderClass="carousel-slider"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    deviceType={deviceType}
                    showDots={false}
                    arrows={false}
                  >
                    {logos.map(({ src, height, url }, idx) => (
                      <div key={idx} style={logo_container_style}>
                        <a href={url} target="_blank" rel="noopener noreferrer" onClick={hangleClickForGA}>
                          <img src={src} alt={`Partner logo ${idx + 1}`} style={{ ...logo_style, height }} />
                        </a>
                      </div>
                    ))}
                  </Carousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
